(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"]) return;
  try {
    
  (function () {
    var bar = document.getElementById('oi-announcement-bar');
    if (!bar) return;

    var lastY = window.scrollY;
    var hideThreshold = 40;

    window.addEventListener(
      'scroll',
      function () {
        var y = window.scrollY;
        if (y > hideThreshold && y > lastY) {
          bar.classList.add('oi-scrolled-hide');
        } else if (y < lastY || y <= hideThreshold) {
          bar.classList.remove('oi-scrolled-hide');
        }
        lastY = y;
      },
      { passive: true }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
